/**
 * Flow Ultra JENIS 2 — kod ralat login (T2_*) → kunci ayat untuk PELANGGAN (2026-10-03).
 *
 * Kod datang dari tiga tempat: skrip remote public/scripts/flow-t2-login.js (langkah login),
 * extension flowSession/type2.js (tab / masa / tiket) dan server functions/flowT2Login.js (peti besi / had).
 * Page login Google berbeza ikut akaun → kod baharu akan bertambah: tambah ia di SINI (hosting sahaja,
 * tiada ZIP). Kod yang tiada di sini → ayat umum + kod dalam kurungan (tidak senyap, tidak mentah).
 *
 * ⚠️ TWIN: sesaat (extension)/src/chrome/flowSession/ralatT2.js — salinan untuk Run Flow dari Workspace
 *    (mesej di panel extension / job; BUNDLED → kod baharu hanya sampai ke sana selepas ZIP). Ubah kedua-duanya.
 *
 * Kumpulan = apa yang pelanggan patut BUAT, bukan apa yang rosak:
 *   ulang   — cuba semula sendiri          admin   — hanya admin boleh betulkan (akaun / kata laluan)
 *   semak   — Google minta semakan manusia had     — had credit dicapai
 */
const KUMPULAN = {
    T2_TAB_DITUTUP: 'tab',
    T2_LOGIN_TIMEOUT: 'masa',
    T2_JAMBATAN_TIMEOUT: 'masa',
    T2_LOGIN_CAPTCHA: 'semak',
    T2_LOGIN_PERLU_TELEFON: 'semak',
    T2_PASSWORD_DITOLAK: 'admin',
    T2_GMAIL_TIADA: 'admin',
    T2_2FA_DITOLAK: 'admin',
    T2_VAULT_TIADA: 'admin',
    T2_VAULT_TIADA_2FA: 'admin',
    T2_VAULT_TAK_LENGKAP: 'admin',
    T2_VAULT_GMAIL_TAK_SAMA: 'admin',
    T2_VAULT_GAGAL: 'ulang',
    T2_TIKET_ROSAK: 'ulang',
    T2_OTP_ROSAK: 'ulang',
    T2_LANGKAH_EMAIL_TERSANGKUT: 'halaman',
    T2_LANGKAH_PASSWORD_TERSANGKUT: 'halaman',
    T2_LANGKAH_OTP_TERSANGKUT: 'halaman',
    T2_BUKAN_JENIS2: 'tiadaAkses',
    T2_HAD_KREDIT: 'had',
};
const KUNCI = {
    tab: 'fc.t2.err.tab', masa: 'fc.t2.err.masa', semak: 'fc.t2.err.semak', admin: 'fc.t2.err.admin',
    ulang: 'fc.t2.err.ulang', halaman: 'fc.t2.err.halaman', tiadaAkses: 'fc.st.noAccess', had: 'fc.st.creditLimit',
};
export const kodT2Sah = kod => typeof kod === 'string' && /^T2_[A-Z0-9_]{1,40}$/.test(kod);

/** Ayat penuh untuk pelanggan. Kod sokongan dilampir bila admin memerlukannya untuk mendiagnos. */
export function ayatRalatT2(kod, t) {
    if (!kodT2Sah(kod)) return t('fc.t2.openError');
    const kumpulan = KUMPULAN[kod];
    if (!kumpulan) return t('fc.t2.openError') + ' (' + kod + ')';
    const perluKod = kumpulan === 'admin' || kumpulan === 'semak' || kumpulan === 'halaman';
    return t(KUNCI[kumpulan]) + (perluKod ? ' (' + kod + ')' : '');
}
